/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cap_1_TitleInputs */

const en_mk_cap_1_title = /** @type {(inputs: Mk_Cap_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three views, one set of data`)
};

const id_mk_cap_1_title = /** @type {(inputs: Mk_Cap_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiga tampilan, satu data`)
};

/**
* | output |
* | --- |
* | "Three views, one set of data" |
*
* @param {Mk_Cap_1_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cap_1_title = /** @type {((inputs?: Mk_Cap_1_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cap_1_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cap_1_title(inputs)
	return en_mk_cap_1_title(inputs)
});